(function () {
  'use strict';

  function updateResponsiveZfu() {
    const screenWidth = window.innerWidth;
    const root = document.getElementById('shopify-section-pdp-zfu');
    if (!root) return;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      // ZFU

      const pdpZfuSubtext = root.querySelector('.Pdp-ZFU-Text-Wrapper p');
      if (pdpZfuSubtext) {
        pdpZfuSubtext.classList.remove('text-body-l');
        pdpZfuSubtext.classList.add('text-body-s');
      }

      const pdpZfuAnchorLink = root.querySelector('.Pdp-ZFU-Text-Wrapper a');
      if (pdpZfuAnchorLink) {
        pdpZfuAnchorLink.style.textDecoration = 'underline';
      }
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      // ZFU

      const pdpZfuSubtext = root.querySelector('.Pdp-ZFU-Text-Wrapper p');
      if (pdpZfuSubtext) {
        pdpZfuSubtext.classList.remove('text-body-s');
        pdpZfuSubtext.classList.add('text-body-l');
      }

      const pdpZfuAnchorLink = root.querySelector('.Pdp-ZFU-Text-Wrapper a');
      if (pdpZfuAnchorLink) {
        pdpZfuAnchorLink.style.textDecoration = 'underline';
      }
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      // ZFU

      const pdpZfuSubtext = root.querySelector('.Pdp-ZFU-Text-Wrapper p');
      if (pdpZfuSubtext) {
        pdpZfuSubtext.classList.remove('text-body-s');
        pdpZfuSubtext.classList.add('text-body-l');
      }

      const pdpZfuAnchorLink = root.querySelector('.Pdp-ZFU-Text-Wrapper a');
      if (pdpZfuAnchorLink) {
        pdpZfuAnchorLink.style.textDecoration = 'underline';
      }
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1440) {
      // ZFU

      const pdpZfuSubtext = root.querySelector('.Pdp-ZFU-Text-Wrapper p');
      if (pdpZfuSubtext) {
        pdpZfuSubtext.classList.remove('text-body-s');
        pdpZfuSubtext.classList.add('text-body-l');
      }

      const pdpZfuAnchorLink = root.querySelector('.Pdp-ZFU-Text-Wrapper a');
      if (pdpZfuAnchorLink) {
        pdpZfuAnchorLink.style.textDecoration = 'underline';
      }
    }
  }

  updateResponsiveZfu();
  window.addEventListener('resize', updateResponsiveZfu);
})();
